import {
  admin_toggleEventStatus,
  createCategoryWiseInterest,
  createInterestCategory,
  deleteCategoryWiseInterest,
  deleteEventMedia,
  deleteInterestCategory,
  editCategoryWiseInterest,
  editInterestCategory,
  getAdminCategoryWiseInterest,
  getAdminInterestCategoryList,
  getUser,
  getUserDetails,
  getUserEvent,
  getUserMerchandise,
  loginAdmin,
  toggleCategoryWiseInterest,
  toggleInterestCategoryStatus,
  toggleStatus,
  toggleUserStatus,
  userCheckInEvent,
  getAdminEventTypes,
  toggleEventTypeStatus,
  deleteEventType,
  getAllEvent,
  getUserArtProject,
  toggleArtProjectStatus,
  userAchievementsEvent,
  toggleEventStatus,
  getEventDetails,
  admin_getUserArtLog,
  admin_getArtists_count,
  admin_get_ArtLover,
  adminGetArtRunner,
  editArtRunnerEvent,
  adminGetDashboardEventCount,
  adminChangePassword,
  adminToggleFeaturedUser,
  userArtistList,
  getEventRetainableSettings,
  usersForgotPassword,
  userResetPassword,
  updateUserProfile,
  searchUser,
  searchInterestCategory,
  searchCategoryWiseInterest,
  searchEvent,
  getWithOutCheckInEvent,
  createArtRunnerEvent,
  toggleEventFeatured,
  adminCreateAchievement,
  adminGetAchievement,
  adminDeleteAchievement,
  adminToggleAchievementStatus,
  getRegistrationUser,
  newRegistarionApprove,
  getUserApplicationList,
  userApplicationApprove,
  getCategoryWiseInterestList,
  allUserList,
  getAdminAllEvent,
  searchAdminEvent,
  userArtistTypes,
  addUserArtistType,
  statusChangeArtistTags,
  deleteArtistTypes,
  searchSubmitEvent,
  userAttendEventList,
  addCheckIn,
  getAllMasterEvent,
  searchMasterEvent,
  AttendEventList,
  CheckedAllEventList,
  getReferralHistory,
  subscriptionGetPlan,
  subscriptionCreatePlan,
  subscriptionEditPlan,
  subscriptionUpdatePlanStatus,
  ambassadorRequests,
  ambassadorApproveRejectRequests,
  ambassadorCancelAmbassador,
  getActivatedPlan,
  getSubscriptionPlanHistory,
  getAllExpieredPlanHistory,
  getKpiTracking,
  getKpiUserHistory,
  upgradeUserSubscription,
  getWalletFunds,
  getBookedTicketsDetails,
  getAllBookingList,
  getTicketDetails,
  refundTransaction,
  addAdminProcessingFee,
  updateAdminProcessingFee,
  toggleAdminProcessingFeeStatus,
  getAllAdminProcessingFees,
  getArtrunerWallet,
  getAllExchangeRates,
  getAllConries,
  getAllStates,
  getAllCities,
  changeMasterEvent,
  postArtCancel,
  transferEvent,
  freePlanUpgraded,
  ambassadorAssignByDirectAdmin,
  ambassadorCancelAdminDirectAmbassador,
  getUserActiveSubscriptionPlan,
} from "./ApiEndPoint";
import { baseApiCall } from "./BaseApiCall";

export const postApiLoginAdmin = (data) => {
  return baseApiCall({
    url: loginAdmin,
    method: "post",
    data,
  });
};

export const apiCallUserApplication = (data) => {
  return baseApiCall({
    url: getUserApplicationList,
    method: "get",
    data,
  });
};

export const apiCallGetUser = (data) => {
  return baseApiCall({
    url: getUser,
    method: "post",
    data,
  });
};

export const onGetCategoryWiseInterestList = (data) => {
  return baseApiCall({
    url: getCategoryWiseInterestList,
    method: "post",
    data,
  });
};

export const apiCallUserApplicationApprove = (data) => {
  return baseApiCall({
    url: userApplicationApprove,
    method: "post",
    data,
  });
};
export const apiCallGetRegistrationUser = (data) => {
  return baseApiCall({
    url: getRegistrationUser,
    method: "post",
    data,
  });
};
export const apiCallNewRegistarionApprove = (data) => {
  return baseApiCall({
    url: newRegistarionApprove,
    method: "post",
    data,
  });
};

export const apiCallToggleUserStatus = (data) => {
  return baseApiCall({
    url: toggleUserStatus,
    method: "post",
    data,
  });
};

export const apiCallGetAdminInterestCategoryList = (data) => {
  return baseApiCall({
    url: getAdminInterestCategoryList,
    method: "post",
    data,
  });
};

export const apiCallGetCategoryStatusChange = (data) => {
  return baseApiCall({
    url: toggleInterestCategoryStatus,
    method: "post",
    data,
  });
};

export const apiCallStatusChangeArtistTags = (data) => {
  return baseApiCall({
    url: statusChangeArtistTags,
    method: "post",
    data,
  });
};
export const apiCallDeleteArtistTypes = (data) => {
  return baseApiCall({
    url: deleteArtistTypes,
    method: "post",
    data,
  });
};

export const apiCallDeleteInterestCategory = (data) => {
  return baseApiCall({
    url: deleteInterestCategory,
    method: "post",
    data,
  });
};

export const apiCallCreateInterestCategory = (data) => {
  return baseApiCall({
    url: createInterestCategory,
    method: "post",
    data,
  });
};

export const apiCallEditInterestCategory = (data) => {
  return baseApiCall({
    url: editInterestCategory,
    method: "post",
    data,
  });
};

export const apiCallGetAdminCategoryWiseInterest = (data) => {
  return baseApiCall({
    url: getAdminCategoryWiseInterest,
    method: "post",
    data,
  });
};

export const apiCallAddSubCategoryAdd = (data) => {
  return baseApiCall({
    url: createCategoryWiseInterest,
    method: "post",
    data,
  });
};

export const apiCallToggleCategoryWiseInterest = (data) => {
  return baseApiCall({
    url: toggleCategoryWiseInterest,
    method: "post",
    data,
  });
};

export const apiCallDeleteCategoryWiseInterest = (data) => {
  return baseApiCall({
    url: deleteCategoryWiseInterest,
    method: "post",
    data,
  });
};

export const apiCallEditCategoryWiseInterest = (data) => {
  return baseApiCall({
    url: editCategoryWiseInterest,
    method: "post",
    data,
  });
};

export const apiCallGetUserDetails = (data) => {
  return baseApiCall({
    url: getUserDetails,
    method: "post",
    data,
  });
};

export const apiCallGetUserMerchandise = (data) => {
  return baseApiCall({
    url: getUserMerchandise,
    method: "post",
    data,
  });
};

export const apiCallMerchandiseStatus = (data) => {
  return baseApiCall({
    url: toggleStatus,
    method: "post",
    data,
  });
};

export const apiCallUserCheckInEvent = (data) => {
  return baseApiCall({
    url: userCheckInEvent,
    method: "post",
    data,
  });
};
export const apiCallUserAttendEventList = (data) => {
  return baseApiCall({
    url: userAttendEventList,
    method: "post",
    data,
  });
};
export const apiCallEventAttnedAllGetUser = (data) => {
  return baseApiCall({
    url: AttendEventList,
    method: "post",
    data,
  });
};
export const apiCallCheckEventAllGetUser = (data) => {
  return baseApiCall({
    url: CheckedAllEventList,
    method: "post",
    data,
  });
};

export const apiCallDeleteEventMedia = (data) => {
  return baseApiCall({
    url: deleteEventMedia,
    method: "post",
    data,
  });
};

export const apiCallGetUserWiseAllEvent = (data) => {
  return baseApiCall({
    url: getUserEvent,
    method: "post",
    data,
  });
};

export const apiCall_Admin_ToggleEventStatus = (data) => {
  return baseApiCall({
    url: admin_toggleEventStatus,
    method: "post",
    data,
  });
};

export const apiCall_getAdminEventTypes = (data) => {
  return baseApiCall({
    url: getAdminEventTypes,
    method: "post",
    data,
  });
};

export const apiCallGetUserArtProject = (data) => {
  return baseApiCall({
    url: getUserArtProject,
    method: "post",
    data,
  });
};

export const apiCallPostToggleArtProjectStatus = (data) => {
  return baseApiCall({
    url: toggleArtProjectStatus,

    method: "post",
    data,
  });
};

export const apiCall_toggleEventTypeStatus = (data) => {
  return baseApiCall({
    url: toggleEventTypeStatus,
    method: "post",
    data,
  });
};
export const apiCall_deleteEventType = (data) => {
  return baseApiCall({
    url: deleteEventType,
    method: "post",
    data,
  });
};

export const apiCallPostUserAchievementsEvent = (data) => {
  return baseApiCall({
    url: userAchievementsEvent,
    method: "post",
    data,
  });
};

export const apiCallPostGetArtLog = (data) => {
  return baseApiCall({
    url: admin_getUserArtLog,
    method: "post",
    data,
  });
};
export const apiCallGetAllEvent = (data) => {
  return baseApiCall({
    url: getAllEvent,
    method: "post",
    data,
  });
};
export const apiCallGetAllMasterEvent = (data) => {
  return baseApiCall({
    url: getAllMasterEvent,
    method: "post",
    data,
  });
};
export const apiCallGetAdminAllEvent = (data) => {
  return baseApiCall({
    url: getAdminAllEvent,
    method: "post",
    data,
  });
};
export const apiCallGetEventStatus = (data) => {
  return baseApiCall({
    url: toggleEventStatus,
    method: "post",
    data,
  });
};

export const apiCallUserArtistType = (data) => {
  return baseApiCall({
    url: userArtistTypes,
    method: "get",
    data,
  });
};

export const apiCallGetEventDetails = (data) => {
  return baseApiCall({
    url: getEventDetails,
    method: "post",
    data,
  });
};
export const apiCallAddUserArtistType = (data) => {
  return baseApiCall({
    url: addUserArtistType,
    method: "post",
    data,
  });
};

export const apiCallDashArtistCount = (data) => {
  return baseApiCall({
    url: admin_getArtists_count,
    method: "post",
    data,
  });
};

export const apiCallDashArtLover = (data) => {
  return baseApiCall({
    url: admin_get_ArtLover,
    method: "post",
    data,
  });
};

export const apiCallDAshAdmin_ArtRunner_Count = (data) => {
  return baseApiCall({
    url: adminGetArtRunner,
    method: "post",
    data,
  });
};

export const apiCallEditArtRunnerEvent = (data) => {
  return baseApiCall({
    url: editArtRunnerEvent,
    method: "post",
    data,
  });
};

export const onAPiCallAdminGetDashboardEventCount = (data) => {
  return baseApiCall({
    url: adminGetDashboardEventCount,
    method: "post",
    data,
  });
};

export const onAPiCallAdminChangePassword = (data) => {
  return baseApiCall({
    url: adminChangePassword,
    method: "post",
    data,
  });
};

export const onAPiCallAdminToggleFeaturedUser = (data) => {
  return baseApiCall({
    url: adminToggleFeaturedUser,
    method: "post",
    data,
  });
};

export const onAPiCallUserStartList = (data) => {
  return baseApiCall({
    url: userArtistList,
    method: "post",
    data,
  });
};
export const apiCallEventRetainableSettings = (data) => {
  return baseApiCall({
    url: getEventRetainableSettings,
    method: "post",
    data,
  });
};

export const onApiCallForgotPassword = (data) => {
  return baseApiCall({
    url: usersForgotPassword,
    method: "post",
    data,
  });
};

export const onAPiCallUserResetPassword = (data) => {
  return baseApiCall({
    url: userResetPassword,
    method: "post",
    data,
  });
};

export const onAPiCallUpdateUserProfile = (data) => {
  return baseApiCall({
    url: updateUserProfile,
    method: "post",
    data,
  });
};

export const onAPiCallUserSearchUser = (data) => {
  return baseApiCall({
    url: searchUser,
    method: "post",
    data,
  });
};
export const onApiCallPostGetReferral = (data) => {
  return baseApiCall({
    url: getReferralHistory,
    method: "post",
    data,
  });
};

export const onAPiCallSearchInterestCategory = (data) => {
  return baseApiCall({
    url: searchInterestCategory,
    method: "post",
    data,
  });
};
export const onAPiCallSearchCategoryWiseInterest = (data) => {
  return baseApiCall({
    url: searchCategoryWiseInterest,
    method: "post",
    data,
  });
};

export const onAPiCallSearchEvent = (data) => {
  return baseApiCall({
    url: searchEvent,
    method: "post",
    data,
  });
};
export const onAPiCallSearchMasterEvent = (data) => {
  return baseApiCall({
    url: searchMasterEvent,
    method: "post",
    data,
  });
};
export const onApiCallSubmitEvent = (data) => {
  return baseApiCall({
    url: searchSubmitEvent,
    method: "post",
    data,
  });
};

export const onAPiCallSearchAdminEvent = (data) => {
  return baseApiCall({
    url: searchAdminEvent,
    method: "post",
    data,
  });
};
export const onAPiCallGetWithOutCheckInEvent = (data) => {
  return baseApiCall({
    url: getWithOutCheckInEvent,
    method: "post",
    data,
  });
};

export const onAPiCallCreateArtRunnerEvent = (data) => {
  return baseApiCall({
    url: createArtRunnerEvent,
    method: "post",
    data,
  });
};

export const onAPiCallToggleEventFeatured = (data) => {
  return baseApiCall({
    url: toggleEventFeatured,
    method: "post",
    data,
  });
};

export const onApiCallAdminCreateAchievement = (data) => {
  return baseApiCall({
    url: adminCreateAchievement,
    method: "post",
    data,
  });
};

export const onApiCallGetAchievement = (data) => {
  return baseApiCall({
    url: adminGetAchievement,
    method: "post",
    data,
  });
};

export const onApiCallAdminDeleteAchievement = (data) => {
  return baseApiCall({
    url: adminDeleteAchievement,
    method: "post",
    data,
  });
};

export const onApiAdminToggleAchievementStatus = (data) => {
  return baseApiCall({
    url: adminToggleAchievementStatus,
    method: "post",
    data,
  });
};
export const onApiAllUserList = (data) => {
  return baseApiCall({
    url: allUserList,
    method: "post",
    data,
  });
};
export const apiUpgradeUserSubscription = (data) => {
  return baseApiCall({
    url: upgradeUserSubscription,
    method: "post",
    data,
  });
};

export const apiCallAddCheckIn = (data) => {
  return baseApiCall({
    url: addCheckIn,
    method: "post",
    data,
  });
};

export const apiCallSubscriptionPlanList = (data) => {
  return baseApiCall({
    url: subscriptionGetPlan,
    method: "post",
    data,
  });
};

export const apiCallCreateSubscriptionCreatePlan = (data) => {
  return baseApiCall({
    url: subscriptionCreatePlan,
    method: "post",
    data,
  });
};

export const apiCallCreateSubscriptionEditPlan = (data) => {
  return baseApiCall({
    url: subscriptionEditPlan,
    method: "post",
    data,
  });
};

export const apiCallSubscriptionUpdatePlanStatus = (data) => {
  return baseApiCall({
    url: subscriptionUpdatePlanStatus,
    method: "post",
    data,
  });
};
export const apiCallAmbassadorRequests = (data) => {
  return baseApiCall({
    url: ambassadorRequests,
    method: "post",
    data,
  });
};

export const apiCallAmbassadorApproveRejectRequests = (data) => {
  return baseApiCall({
    url: ambassadorApproveRejectRequests,
    method: "post",
    data,
  });
};
export const apiCallAmbassadorAssignByDirectAdmin = (data) => {
  return baseApiCall({
    url: ambassadorAssignByDirectAdmin,
    method: "post",
    data,
  });
};
export const apiCallCancelDirectSubscription = (data) => {
  return baseApiCall({
    url: ambassadorCancelAdminDirectAmbassador,
    method: "post",
    data,
  });
};

export const apiCallAmbassadorCancel = (data) => {
  return baseApiCall({
    url: ambassadorCancelAmbassador,
    method: "post",
    data,
  });
};
export const apiCallGetUserActiveSubscriptionPlan = (data) => {
  return baseApiCall({
    url: getUserActiveSubscriptionPlan,
    method: "post",
    data,
  });
};
export const apiCallFreePlanUpgraded = (data) => {
  return baseApiCall({
    url: freePlanUpgraded,
    method: "post",
    data,
  });
};

export const apiCallGetActivatedPlan = (data) => {
  return baseApiCall({
    url: getActivatedPlan,
    method: "post",
    data,
  });
};

export const apiCallGetSubscriptionPlanHistory = (data) => {
  return baseApiCall({
    url: getSubscriptionPlanHistory,
    method: "post",
    data,
  });
};

export const apiCallExpieredPlanHistory = (data) => {
  return baseApiCall({
    url: getAllExpieredPlanHistory,
    method: "post",
    data,
  });
};

export const apiCallGetWalletFunds = (data) => {
  return baseApiCall({
    url: getWalletFunds,
    method: "post",
    data,
  });
};

export const apiCallGetArtrunerWallet = (data) => {
  return baseApiCall({
    url: getArtrunerWallet,
    method: "post",
    data,
  });
};

export const apiCallGetKpiMatrix = (data) => {
  return baseApiCall({
    url: getKpiTracking,
    method: "post",
    data,
  });
};
export const apiCallGetKPIUserHistory = (data) => {
  return baseApiCall({
    url: getKpiUserHistory,
    method: "post",
    data,
  });
};

export const apiCallGetBookedTicketsDetails = (data) => {
  return baseApiCall({
    url: getBookedTicketsDetails,
    method: "post",
    data,
  });
};

export const apiCallGetAllBookingList = (data) => {
  return baseApiCall({
    url: getAllBookingList,
    method: "post",
    data,
  });
};

export const apiCallGetTicketDetails = (data) => {
  return baseApiCall({
    url: getTicketDetails,
    method: "post",
    data,
  });
};

export const apiCallRefundTransaction = (data) => {
  return baseApiCall({
    url: refundTransaction,
    method: "post",
    data,
  });
};

export const apiCallAddAdminProcessingFee = (data) => {
  return baseApiCall({
    url: addAdminProcessingFee,
    method: "post",
    data,
  });
};

export const apiCallUpdateAdminProcessingFee = (data) => {
  return baseApiCall({
    url: updateAdminProcessingFee,
    method: "post",
    data,
  });
};

export const apiCallToggleAdminProcessingFeeStatus = (data) => {
  return baseApiCall({
    url: toggleAdminProcessingFeeStatus,
    method: "post",
    data,
  });
};

export const apiCallGetAllAdminProcessingFees = (data) => {
  return baseApiCall({
    url: getAllAdminProcessingFees,
    method: "post",
    data,
  });
};

export const apiCallGetAllExchangeRate = (data) => {
  return baseApiCall({
    url: getAllExchangeRates,
    method: "post",
    data,
  });
};

export const apiCallGetAllCities = (data) => {
  return baseApiCall({
    url: getAllCities,
    method: "post",
    data,
  });
};

export const apiCallGetAllStates = (data) => {
  return baseApiCall({
    url: getAllStates,
    method: "post",
    data,
  });
};

export const apiCallGetAllContreies = (data) => {
  return baseApiCall({
    url: getAllConries,
    method: "post",
    data,
  });
};
export const apiCallChangeMasterEvent = (data) => {
  return baseApiCall({
    url: changeMasterEvent,
    method: "post",
    data,
  });
};

export const apiCallPostArtCancel = (data) => {
  return baseApiCall({
    url: postArtCancel,
    method: "post",
    data,
  });
};

export const apiCallTransferEvent = (data) => {
  return baseApiCall({
    url: transferEvent,
    method: "post",
    data,
  });
};
